import { combineReducers } from '@reduxjs/toolkit';
import shopping from "./shoppingSlice";
;


const shoppingReducer = combineReducers({
    shopping
});

export default shoppingReducer;